'use strict';

var helpers = require('./helpers');


var sitewit;

var init = function(scriptUrl) {
  if (!sitewit._init) {
    sitewit._init = helpers.importScript('//' + scriptUrl);
  }

  return sitewit._init;
};

var analytics = function() {
  return window.yolastats;
};

var send = function() {
  return new Promise(function(resolve) {
    analytics().register_page_view(resolve);
  });
};

var identify = function(userId) {
  var log = function() {
    console.info('SiteWit has registered user ID: ' + userId);
  };

  analytics().user.set_site_unique_id(userId);

  return send().then(log);
};

var page = function() {
  var log = function() {
    console.info('SiteWit has registered the current page view.');
  };

  return send().then(log);
};

var reset = function() {
  sitewit._init = null;
  delete window.yolastats;
};

sitewit = {
  _init: null,
  analytics: analytics,
  identify: identify,
  init: init,
  page: page,
  reset: reset
};

module.exports = sitewit;
